import { useEffect, useState } from "react";
import { Button, CssBaseline, Typography } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/core/styles";
import theme from "@/theme/muiTheme";
import Loading from "@/containers/Loading";
import DateTimePickerLocalizationProvider from "@/DateTimePickerLocalizationProvider";
import {
  LOCALFORAGE_INITIATE,
  initAxiosInterceptors
} from "./initiates/initiate";
import { setAppEnv } from "./APP_ENV";
import { setGoUrlDeterminer, setUrlDeterminer } from "@/apis/apiSetup";

function initMisc() {
  LOCALFORAGE_INITIATE();
  initAxiosInterceptors();
}

function getEnvHostname() {
  if (process.env.NODE_ENV === "development") {
    return process.env.REACT_APP_API_URL.replace("-api", "");
  }
  return window.location.origin;
}

export default function AppWrapper({ children }) {
  const [isInitiated, setInitiated] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(getEnvHostname() + process.env.REACT_APP_ENV_API_PATH)
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP ERROR! Status: ${res.status}`);
        }
        return res.json();
      })
      .then(res => {
        setAppEnv(res.env);
        setUrlDeterminer(res.env.REACT_APP_API_PREFIX);
        setGoUrlDeterminer(res.env.REACT_APP_API_PREFIX);
        initMisc();
        setInitiated(true);
      })
      .catch(err => {
        console.error(err);
        setError(err);
      });
  }, []);

  if (!isInitiated && !error) {
    return <Loading />;
  }
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
        <DateTimePickerLocalizationProvider>
          {error ? (
            <div className="error-wrapper">
              <Typography variant="h6">Initialization Error</Typography>
              <Typography variant="body1" style={{ margin: "10px 0 20px" }}>
                {error.message}
              </Typography>
              <Button
                color="primary"
                variant="contained"
                onClick={() => window.location.reload()}
              >
                Reload
              </Button>
            </div>
          ) : (
            children
          )}
        </DateTimePickerLocalizationProvider>
    </ThemeProvider>
  );
}
